// extracted by mini-css-extract-plugin
module.exports = {"footer":"FormFooter_footer__37obk"};